import React from 'react';
import { Recognitions, MediaPartners, SocialFollow } from '../components';
import './pages.css';

const GalleryPage = () => {
  return (
    <div className="page page--gallery">
      <section className="page__hero page__hero--gallery page__hero--compact page__hero--gallery-compact">
        <div className="page__hero-content">
          <h1 className="gradient__text page__hero-title">Testimonials</h1>
        </div>
      </section>

      <div className="section__padding">
        <Recognitions />
        <MediaPartners />
        <SocialFollow />
      </div>
    </div>
  );
};

export default GalleryPage;
